module.exports = __webpack_public_path__ + "static/media/buildspace_logo.9180ca9f.jpeg";